
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire09bf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire09bf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cuPh8", function(module, exports) {

$parcel$export(module.exports, "savePlayers", () => $91900f9c9606830c$export$b10e85661c2e0b54);
$parcel$export(module.exports, "getPlayers", () => $91900f9c9606830c$export$3f6e1f894e09ddae);
$parcel$export(module.exports, "savePlayer", () => $91900f9c9606830c$export$9e9c53f62d57885b);
$parcel$export(module.exports, "deletePlayer", () => $91900f9c9606830c$export$27dfca9de3bf49a6);
$parcel$export(module.exports, "deletePlayers", () => $91900f9c9606830c$export$9a48c9626dec4cdf);

var $cyBds = parcelRequire("cyBds");
const $91900f9c9606830c$export$b10e85661c2e0b54 = (players)=>{
    localStorage.setItem("players", JSON.stringify(players));
    window.dispatchEvent($91900f9c9606830c$var$playersChangedEvent);
};
const $91900f9c9606830c$export$3f6e1f894e09ddae = ()=>{
    const players = localStorage.getItem("players");
    if (players) return JSON.parse(players).map((p)=>new (0, $cyBds.Player)(p.identifier, p.name, p.coefficient, p.goalkeeper));
    return [];
};
const $91900f9c9606830c$export$9e9c53f62d57885b = (player)=>{
    const players = $91900f9c9606830c$export$3f6e1f894e09ddae();
    players.push(player);
    $91900f9c9606830c$export$b10e85661c2e0b54(players);
    return players.length;
};
const $91900f9c9606830c$export$27dfca9de3bf49a6 = (identifier)=>{
    const players = $91900f9c9606830c$export$3f6e1f894e09ddae();
    const index = players.findIndex((p)=>p.identifier === identifier);
    players.splice(index, 1);
    $91900f9c9606830c$export$b10e85661c2e0b54(players);
    return players.length;
};
const $91900f9c9606830c$export$9a48c9626dec4cdf = ()=>{
    localStorage.removeItem("players");
    window.dispatchEvent($91900f9c9606830c$var$playersChangedEvent);
};
const $91900f9c9606830c$var$playersChangedEvent = new CustomEvent("playersChanged");

});
parcelRegister("cyBds", function(module, exports) {

$parcel$export(module.exports, "Player", () => $9245875c1e07eb50$export$2616165974278734);
class $9245875c1e07eb50$export$2616165974278734 {
    constructor(identifier, name, coefficient, goalkeeper){
        this.identifier = identifier;
        this.name = name;
        this.coefficient = coefficient;
        this.goalkeeper = goalkeeper;
    }
}

});


parcelRegister("8TdeO", function(module, exports) {

$parcel$export(module.exports, "generatePlayerRows", () => $678dba8a331ced98$export$95966af3a9aec66b);
$parcel$export(module.exports, "appendTeamsResult", () => $678dba8a331ced98$export$421fe94206e02575);

var $s9t2A = parcelRequire("s9t2A");

var $7nhm9 = parcelRequire("7nhm9");
const $678dba8a331ced98$export$95966af3a9aec66b = (players)=>{
    const playerRows = [];
    for (const player of players){
        // Create cell elements
        const row = document.createElement("tr");
        const checkboxCell = document.createElement("td");
        const nameCell = document.createElement("td");
        const coefficientCell = document.createElement("td");
        const goalKeeperCell = document.createElement("td");
        const actionCell = document.createElement("td");
        // Create and append text nodes to cell elements
        nameCell.appendChild(document.createTextNode(player.name));
        if (player.goalkeeper) {
            const goalkeeperBadge = $678dba8a331ced98$var$createCoefficientBadgeElement(player.goalkeeper);
            goalKeeperCell.appendChild(goalkeeperBadge);
        }
        const coefficientBadge = $678dba8a331ced98$var$createCoefficientBadgeElement(player.coefficient);
        coefficientCell.appendChild(coefficientBadge);
        const playerCheckbox = $678dba8a331ced98$var$createCheckboxElement(player);
        checkboxCell.appendChild(playerCheckbox);
        const deleteBtn = $678dba8a331ced98$var$createDeleteButtonElement(player);
        actionCell.appendChild(deleteBtn);
        // Append cell elements to row
        row.appendChild(checkboxCell);
        row.appendChild(nameCell);
        row.appendChild(coefficientCell);
        row.appendChild(goalKeeperCell);
        row.appendChild(actionCell);
        row.dataset.identifier = player.identifier;
        // Append row to table body
        playerRows.push(row);
    }
    return playerRows;
};
const $678dba8a331ced98$var$createDeleteButtonElement = (player)=>{
    const deleteBtn = document.createElement("button");
    deleteBtn.classList.add("btn", "btn-danger", "delete-player-button");
    deleteBtn.ariaLabel = "Delete row";
    const trashIcon = document.createElement("i");
    trashIcon.classList.add("bi", "bi-trash");
    deleteBtn.appendChild(trashIcon);
    return deleteBtn;
};
const $678dba8a331ced98$var$createCheckboxElement = (player)=>{
    const checkboxContainer = document.createElement("div");
    checkboxContainer.classList.add("form-check");
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.id = player.identifier;
    checkbox.checked = true;
    checkbox.classList.add("form-check-input");
    checkboxContainer.appendChild(checkbox);
    return checkboxContainer;
};
const $678dba8a331ced98$var$createCoefficientBadgeElement = (coefficient)=>{
    const coefficientBadge = document.createElement("span");
    coefficientBadge.classList.add("badge", "rounded-pill");
    switch(coefficient){
        case 1:
            coefficientBadge.classList.add("bg-success");
            break;
        case 2:
            coefficientBadge.classList.add("bg-secondary");
            break;
        case 3:
            coefficientBadge.classList.add("bg-warning");
            break;
        default:
            coefficientBadge.classList.add("bg-danger");
            break;
    }
    coefficientBadge.appendChild(document.createTextNode(coefficient));
    return coefficientBadge;
};
const $678dba8a331ced98$export$421fe94206e02575 = (teams)=>{
    const teamResultContainerDiv = document.getElementById("teamResultContainerDiv");
    // Reset teams result container
    teamResultContainerDiv.innerHTML = "";
    const copyOfTeamColors = [
        ...(0, $s9t2A.teamColorClasses)
    ];
    let row = document.createElement("div");
    row.classList.add("row", "mt-3");
    let teamIndex = 0;
    for (const team of teams){
        const teamColor = copyOfTeamColors.shift();
        const teamCard = $678dba8a331ced98$var$generateTeamCard(team, teamColor, teamIndex);
        row.appendChild(teamCard);
        teamIndex++;
        if (teamIndex % 3 === 0) {
            teamResultContainerDiv.appendChild(row);
            row = document.createElement("div");
            row.classList.add("row", "mt-3");
        }
    }
    if (teamIndex % 3 !== 0) teamResultContainerDiv.appendChild(row);
};
const $678dba8a331ced98$var$generateTeamCard = (team, teamColor, teamIndex)=>{
    const col = document.createElement("div");
    col.classList.add("col-4");
    const teamCard = document.createElement("div");
    teamCard.classList.add("card");
    // Header
    const teamCardHeader = document.createElement("div");
    teamCardHeader.classList.add("card-header", teamColor);
    const teamCardHeaderContainer = document.createElement("div");
    teamCardHeaderContainer.classList.add("d-flex", "justify-content-between", "align-items-center");
    const teamCardTitle = document.createElement("span");
    teamCardTitle.innerText = `Team ${teamIndex + 1}`;
    const teamCardBadge = document.createElement("span");
    teamCardBadge.classList.add("badge", "bg-secondary", "rounded-pill");
    teamCardBadge.innerText = (0, $7nhm9.getTeamTotalCoefficient)(team);
    teamCardHeaderContainer.appendChild(teamCardTitle);
    teamCardHeaderContainer.appendChild(teamCardBadge);
    teamCardHeader.appendChild(teamCardHeaderContainer);
    // Body
    const teamCardBody = document.createElement("ul");
    teamCardBody.classList.add("list-group", "list-group-flush");
    for (const player of team){
        const teamCardItem = document.createElement("li");
        teamCardItem.classList.add("list-group-item");
        teamCardItem.innerText = `${player.name} (${player.coefficient})`;
        teamCardBody.appendChild(teamCardItem);
    }
    teamCard.appendChild(teamCardHeader);
    teamCard.appendChild(teamCardBody);
    col.appendChild(teamCard);
    return col;
};

});
parcelRegister("s9t2A", function(module, exports) {

$parcel$export(module.exports, "teamColorClasses", () => $0549f5aaef62b2d2$export$57c463335f0b68b7);
const $0549f5aaef62b2d2$export$57c463335f0b68b7 = [
    "text-bg-success",
    "text-bg-warning",
    "text-bg-secondary",
    "text-bg-primary",
    "text-bg-danger"
];

});

parcelRegister("7nhm9", function(module, exports) {

$parcel$export(module.exports, "getSelectedPlayers", () => $55e824ff15c161b3$export$d5a588ebeecf6998);
$parcel$export(module.exports, "shuffleArray", () => $55e824ff15c161b3$export$7ac3a88d34a76e7);
$parcel$export(module.exports, "getTeamTotalCoefficient", () => $55e824ff15c161b3$export$e7f71068449aadb7);
const $55e824ff15c161b3$export$d5a588ebeecf6998 = (players)=>{
    const selectedPlayers = [];
    for (const player of players){
        const checkbox = document.getElementById(player.identifier);
        if (checkbox?.checked) selectedPlayers.push(player);
    }
    return selectedPlayers;
};
const $55e824ff15c161b3$export$7ac3a88d34a76e7 = (arr)=>{
    if (!arr.length) return [];
    if (arr.length === 1) return arr;
    const copy = [
        ...arr
    ];
    for(let i = copy.length - 1; i > 0; i--){
        const randomIndex = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[randomIndex]] = [
            copy[randomIndex],
            copy[i]
        ];
    }
    return copy;
};
const $55e824ff15c161b3$export$e7f71068449aadb7 = (team)=>{
    return team.reduce((accumulator, player)=>accumulator + player.coefficient, 0);
};

});



var $cuPh8 = parcelRequire("cuPh8");

var $8TdeO = parcelRequire("8TdeO");
/*
 * When document is ready get players from localstorage and append them to table
 */ document.addEventListener("DOMContentLoaded", ()=>{
    const playersTableBody = document.getElementById("playersTableBody");
    const totalPlayersSpan = document.getElementById("totalPlayers");
    const coefficientInput = document.getElementById("coefficientInput");
    coefficientInput.value = 1;
    const players = (0, $cuPh8.getPlayers)();
    const playerRows = (0, $8TdeO.generatePlayerRows)(players);
    totalPlayersSpan.innerText = players.length;
    playersTableBody.append(...playerRows);
});


//# sourceMappingURL=index.30f6cf2b.js.map
